import { ROUTES } from "@/types/routes";
import { Button, Flex, Grid, Image, Typography } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router";
import bannerBg from '@/assets/images/subscription-banner-bg.webp'
import './index.scss'
import { SvgIcon } from "@/components/icon";

export const SubscriptionBanner: FC = () => {
  const navigate = useNavigate();
  const { lg } = Grid.useBreakpoint()

  return (
    <Flex
      className={'subscription-banner'}
      gap={16}
      justify={"space-between"}
      align={"center"}
    >
      <Flex
        align={'center'}
        vertical={!lg}
        className={'inner-container'}
      >
        <img className={'banner-bg'} src={bannerBg} />
        <SvgIcon className={'stars'} type={'starFall'} />
        <Flex vertical gap={12}>
          <Typography.Text
            className={'title'}
            style={{
              fontSize: '26px',
              fontWeight: 600,
              lineHeight: 'normal',
            }}
          >
            Start Booking Calls
          </Typography.Text>

          <Typography.Text
            className="section-description"
            style={{
              color: '#49586F',
              fontWeight: 400,
              fontSize: '16px',
            }}
          >
            To begin messaging and booking meetings with Consultants
          </Typography.Text>
        </Flex>

        <Button
          className={'custom-button primary banner-button'}
          type="primary"
          onClick={() => navigate(ROUTES.MY_PROFILE_SUBSCRIPTION)}
        >
          Activate Your Subscription
        </Button>
      </Flex>
    </Flex>
  )
}